import { render } from "./PlusSquareIcon.vue?vue&type=template&id=cebc46d0"
const script = {}
script.render = render

export default script